import React, { useEffect, useState } from "react";
import {
	VerticalTimeline,
	VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { HomeTitle } from "../components";
import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import { BsQuestion } from "react-icons/bs";

const FAQ = () => {
	const [lang] = useLang();
	const langWords = useWords(lang);
	useTitle(langWords.faq || "");
	const [showPartners, setShowPartners] = useState(false);
	const [currentFAQs, setCurrentFAQs] = useState(langWords?.faqs?.client);

	useEffect(() => {
		if (showPartners) setCurrentFAQs(langWords?.faqs?.partner);
		else setCurrentFAQs(langWords?.faqs?.client);
	}, [showPartners, langWords]);

	return (
		<div style={{ marginTop: "120px" }} className="">
			<HomeTitle title={langWords?.faq} center />
			<p className="text-center -mt-4 opacity-70">{langWords?.faqSubTitle}</p>
			<img
				src="/assets/illustrations/faq.svg"
				alt="personThinking"
				className="mx-auto mt-8"
			/>
			<div className="flex justify-center gap-4 mt-14">
				<button
					className={`btn text-xl ${showPartners ? "btn-light" : "btn-dark"}`}
					onClick={() => setShowPartners(false)}
				>
					{langWords?.client}
				</button>
				<button
					className={`btn text-xl ${!showPartners ? "btn-light" : "btn-dark"}`}
					onClick={() => setShowPartners(true)}
				>
					{langWords?.partners}
				</button>
			</div>
			<section>
				{currentFAQs && (
					<VerticalTimeline>
						{currentFAQs.map((faq, index) => (
							<VerticalTimelineElement
								key={index}
								className="vertical-timeline-element--work"
								contentStyle={{ background: "#fafafa", color: "#3f3f46" }}
								contentArrowStyle={{ borderRight: "7px solid  #3f3f46" }}
								iconStyle={{ background: "#FF6584", color: "#fff" }}
								icon={<BsQuestion />}
							>
								<h3 className="vertical-timeline-element-title font-bold text-2xl capitalize">
									{faq.question}
								</h3>
								<p className="opacity-80">{faq.answer}</p>
							</VerticalTimelineElement>
						))}
					</VerticalTimeline>
				)}
			</section>
		</div>
	);
};

export default FAQ;
